export default [
    {
        id: "choose",
        title: "Хичээл сонголт",
        icon: <i className="fal fa-home"></i>,
        navLink: "/study-plan/choose/"
    },
]
